import { useTranslation } from 'react-i18next';

import { UserAvatar } from '@components/Community';
import ShareCardModal, { MEDIA_SIZE } from '@modals/Share/ShareCardModal';

/**
 * ShareProfileModal — the share card named for a person: the avatar, the
 * display name and the @handle over the profile's public link. Everything else
 * (stage, channels, tints, PNG export) belongs to ShareCardModal.
 */
export default function ShareProfileModal({ open, user, url, onClose }) {
    const { t } = useTranslation('member');

    if (!user) return null;

    return (
        <ShareCardModal
            open={open}
            url={url}
            onClose={onClose}
            title={t('publicProfile.share.title')}
            subtitle={t('publicProfile.share.subtitle')}
            shareText={t('publicProfile.share.shareText', { name: user.username || '' })}
            fileSlug={user.nickname || user.username || t('publicProfile.share.fileSlug')}
            card={{
                media: <UserAvatar user={user} size={MEDIA_SIZE} link={false} />,
                name: user.username,
                caption: user.nickname ? `@${user.nickname}` : undefined,
                image: user.avatar,
                shape: 'circle',
            }}
        />
    );
}
